import { getMemberTypeFromBoard } from './getMemberTypeFromBoard';
import type { MemberType } from './memberType.types';

export const isMemberTypeOfBoard = (
  member: {
    id: string;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  } & {
    idEnterprisesAdmin?: string[] | null;
  },
  board: {
    memberships: {
      deactivated: boolean;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
      unconfirmed: boolean;
    }[];
  },
  organization:
    | ({ id: string; offering: string } & {
        memberships: ({
          deactivated: boolean;
          idMember: string;
          memberType: 'admin' | 'normal';
          unconfirmed: boolean;
        } & {
          id?: string;
        })[];
        enterprise?: {
          id?: string;
          idAdmins?: Array<string>;
        } | null;
      })
    | null
    | undefined,
  memberType: MemberType,
  implicitAdmin = true,
): boolean => {
  return (
    getMemberTypeFromBoard(member, board, organization, implicitAdmin) ===
    memberType
  );
};
